exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.rotate180[data-v-cedc8128] {\n\t-webkit-transform: rotate(-180deg);\n\ttransform: rotate(-180deg);\n\tdisplay: initial;\n\tvertical-align: initial;\n\tmargin-right: 5px;\n}\n", ""]);

// exports
